module.exports = __webpack_public_path__ + "img/4.6c36d7f2.png";